import { Banner, Switch } from '@cloudflare/kumo';
import { useCallback, useEffect, useState } from 'react';
import { useAuthenticatedFetch } from '../hooks/useAuthenticatedFetch';
import { useAppToast } from '../hooks/useAppToast';
import { useTenant } from '../contexts/TenantContext';

interface OrgSecurity {
  requireMfa: boolean;
  members: Array<{ id: string; nome: string; email: string; protected: boolean }>;
}

/** Exigir verificação em duas etapas dos membros (como no MongoDB Atlas) */
export function OrgSecurityCard() {
  const fetchApi = useAuthenticatedFetch();
  const toast = useAppToast();
  const { can } = useTenant();
  const [data, setData] = useState<OrgSecurity | null>(null);
  const [saving, setSaving] = useState(false);
  const [error, setError] = useState<string | null>(null);

  const load = useCallback(async () => {
    const res = await fetchApi('/api/user-tenants/security');
    if (res.ok) setData(await res.json());
  }, [fetchApi]);
  useEffect(() => { load(); }, [load]);

  const toggle = async (checked: boolean) => {
    setSaving(true);
    setError(null);
    try {
      const res = await fetchApi('/api/user-tenants/security', { method: 'PATCH', body: JSON.stringify({ requireMfa: checked }) });
      const body = await res.json().catch(() => ({}));
      if (!res.ok) throw new Error(body.message || 'Não foi possível salvar');
      toast.success(checked ? 'Verificação em duas etapas agora é obrigatória' : 'Verificação em duas etapas deixou de ser obrigatória');
      load();
    } catch (err) {
      setError(err instanceof Error ? err.message : 'Não foi possível salvar');
    } finally {
      setSaving(false);
    }
  };

  if (!data) return null;
  const unprotected = data.members.filter((m) => !m.protected);

  return (
    <div className="org-card" style={{ marginTop: 24 }}>
      <div className="org-card__header">
        <h3 className="text-lg font-semibold org-card__title">Exigir verificação em duas etapas</h3>
        <Switch onCheckedChange={(checked: boolean) => toggle(checked)} aria-label="Exigir verificação em duas etapas" checked={data.requireMfa} disabled={saving || !can('org:update')} />
      </div>
      <div>Membros sem aplicativo autenticador nem passkey só conseguem acessar Minha conta até configurar.</div>
      <div className="text-kumo-subtle text-xs" style={{ marginTop: 8 }}>
        {unprotected.length === 0
          ? 'Todos os membros já têm verificação em duas etapas ou passkey.'
          : `${data.members.length - unprotected.length} de ${data.members.length} membros protegidos. Sem proteção: ${unprotected.map((m) => m.nome).join(', ')}.`}
      </div>
      {error && <div style={{ marginTop: 12 }}><Banner variant="error" description={<>{error}</>} /></div>}
    </div>
  );
}
